export const genelBakisMetrikleri = {
  toplamZiyaretci: 12847,
  toplamBasvuru: 1423,
  whatsappTiklamalari: 876,
  ortalamaKalmaSuresi: "4:32",
  ziyaretciTrend: 12.4,
  basvuruTrend: 8.7,
  whatsappTrend: 15.2,
  sureTrend: -2.1,
};

export const haftalikZiyaretci = [
  { gun: "Pzt", ziyaretci: 1420, basvuru: 142 },
  { gun: "Sal", ziyaretci: 1850, basvuru: 198 },
  { gun: "Çar", ziyaretci: 1640, basvuru: 175 },
  { gun: "Per", ziyaretci: 2100, basvuru: 231 },
  { gun: "Cum", ziyaretci: 2380, basvuru: 267 },
  { gun: "Cmt", ziyaretci: 1920, basvuru: 198 },
  { gun: "Paz", ziyaretci: 1537, basvuru: 212 },
];

export const enCokIncelenenKampanya = {
  ad: "Yaz Tatili Paketi 2025",
  goruntulenme: 4821,
  donusum: 18.4,
  renk: "#F59E0B",
};

export const enYuksekDonusumKampanya = {
  ad: "Erken Rezervasyon Fırsatı",
  goruntulenme: 2340,
  donusum: 34.7,
  renk: "#10B981",
};

export const ziyaretciFunnel = [
  { adim: "Siteye Giriş", sayi: 12847, yuzde: 100, renk: "#2B6EFD", ikon: "ri-global-line" },
  { adim: "Kampanya İnceleme", sayi: 9840, yuzde: 76.6, renk: "#8B5CF6", ikon: "ri-eye-line" },
  { adim: "Detay Sayfası", sayi: 6720, yuzde: 52.3, renk: "#F59E0B", ikon: "ri-file-text-line" },
  { adim: "İkinci Adım", sayi: 3890, yuzde: 30.3, renk: "#EC4899", ikon: "ri-arrow-right-circle-line" },
  { adim: "Form / WhatsApp", sayi: 1423, yuzde: 11.1, renk: "#10B981", ikon: "ri-chat-check-line" },
  { adim: "Çıkış", sayi: 11424, yuzde: 88.9, renk: "#EF4444", ikon: "ri-logout-box-line" },
];

export const kampanyalar = [
  {
    id: 1,
    ad: "Yaz Tatili Paketi 2025",
    goruntulenme: 4821,
    ortSure: "5:12",
    tiklama: 1240,
    tiklamaOrani: 25.7,
    donusum: 18.4,
    donusumTrend: 3.2,
    durum: "Aktif",
    kategori: "Tatil",
  },
  {
    id: 2,
    ad: "Erken Rezervasyon Fırsatı",
    goruntulenme: 2340,
    ortSure: "6:45",
    tiklama: 980,
    tiklamaOrani: 41.9,
    donusum: 34.7,
    donusumTrend: 8.1,
    durum: "Aktif",
    kategori: "Fırsat",
  },
  {
    id: 3,
    ad: "Balayı Özel Paketi",
    goruntulenme: 1890,
    ortSure: "4:20",
    tiklama: 620,
    tiklamaOrani: 32.8,
    donusum: 22.1,
    donusumTrend: -1.4,
    durum: "Aktif",
    kategori: "Özel",
  },
  {
    id: 4,
    ad: "Aile Tatil Kampanyası",
    goruntulenme: 3210,
    ortSure: "3:55",
    tiklama: 840,
    tiklamaOrani: 26.2,
    donusum: 14.8,
    donusumTrend: -3.7,
    durum: "Aktif",
    kategori: "Aile",
  },
  {
    id: 5,
    ad: "İş Seyahati Paketi",
    goruntulenme: 1120,
    ortSure: "2:30",
    tiklama: 310,
    tiklamaOrani: 27.7,
    donusum: 9.2,
    donusumTrend: 1.1,
    durum: "Pasif",
    kategori: "İş",
  },
  {
    id: 6,
    ad: "Kış Tatili Özel Teklif",
    goruntulenme: 2780,
    ortSure: "4:48",
    tiklama: 720,
    tiklamaOrani: 25.9,
    donusum: 19.6,
    donusumTrend: 5.3,
    durum: "Aktif",
    kategori: "Tatil",
  },
];

export const basvurular = [
  {
    id: 1,
    adSoyad: "Ahmet Yılmaz",
    telefon: "0532 XXX XX 41",
    telefonTam: "0532 847 12 41",
    kampanya: "Yaz Tatili Paketi 2025",
    asama: 4,
    toplamAsama: 5,
    whatsapp: true,
    tarih: "2025-04-03T10:24:00",
    email: "ahmet.yilmaz@email.com",
    timeline: [
      { aksiyon: "Siteye giriş yaptı", zaman: "10:24", ikon: "ri-global-line", renk: "#2B6EFD" },
      { aksiyon: "Yaz Tatili Paketi 2025 kampanyasını açtı", zaman: "10:26", ikon: "ri-eye-line", renk: "#8B5CF6", sure: "3 dk kaldı" },
      { aksiyon: "Detay sayfasına geçti", zaman: "10:29", ikon: "ri-file-text-line", renk: "#F59E0B" },
      { aksiyon: "İkinci adıma geçti", zaman: "10:32", ikon: "ri-arrow-right-circle-line", renk: "#EC4899" },
      { aksiyon: "WhatsApp butonuna tıkladı", zaman: "10:35", ikon: "ri-whatsapp-line", renk: "#25D366", basarili: true },
    ],
  },
  {
    id: 2,
    adSoyad: "Fatma Kaya",
    telefon: "0545 XXX XX 78",
    telefonTam: "0545 321 09 78",
    kampanya: "Erken Rezervasyon Fırsatı",
    asama: 5,
    toplamAsama: 5,
    whatsapp: true,
    tarih: "2025-04-03T09:15:00",
    email: "fatma.kaya@email.com",
    timeline: [
      { aksiyon: "Siteye giriş yaptı", zaman: "09:15", ikon: "ri-global-line", renk: "#2B6EFD" },
      { aksiyon: "Erken Rezervasyon Fırsatı kampanyasını açtı", zaman: "09:17", ikon: "ri-eye-line", renk: "#8B5CF6", sure: "6 dk kaldı" },
      { aksiyon: "Detay sayfasına geçti", zaman: "09:23", ikon: "ri-file-text-line", renk: "#F59E0B" },
      { aksiyon: "İkinci adıma geçti", zaman: "09:26", ikon: "ri-arrow-right-circle-line", renk: "#EC4899" },
      { aksiyon: "WhatsApp butonuna tıkladı", zaman: "09:29", ikon: "ri-whatsapp-line", renk: "#25D366", basarili: true },
      { aksiyon: "Form doldurdu", zaman: "09:31", ikon: "ri-file-edit-line", renk: "#10B981", basarili: true },
    ],
  },
  {
    id: 3,
    adSoyad: "Mehmet Demir",
    telefon: "0506 XXX XX 23",
    telefonTam: "0506 654 33 23",
    kampanya: "Balayı Özel Paketi",
    asama: 3,
    toplamAsama: 5,
    whatsapp: false,
    tarih: "2025-04-03T08:45:00",
    email: "mehmet.demir@email.com",
    timeline: [
      { aksiyon: "Siteye giriş yaptı", zaman: "08:45", ikon: "ri-global-line", renk: "#2B6EFD" },
      { aksiyon: "Balayı Özel Paketi kampanyasını açtı", zaman: "08:47", ikon: "ri-eye-line", renk: "#8B5CF6", sure: "4 dk kaldı" },
      { aksiyon: "Detay sayfasında çıkış yaptı", zaman: "08:51", ikon: "ri-logout-box-line", renk: "#EF4444", kayip: true },
    ],
  },
  {
    id: 4,
    adSoyad: "Zeynep Arslan",
    telefon: "0533 XXX XX 67",
    telefonTam: "0533 112 45 67",
    kampanya: "Aile Tatil Kampanyası",
    asama: 5,
    toplamAsama: 5,
    whatsapp: false,
    tarih: "2025-04-02T16:30:00",
    email: "zeynep.arslan@email.com",
    timeline: [
      { aksiyon: "Siteye giriş yaptı", zaman: "16:30", ikon: "ri-global-line", renk: "#2B6EFD" },
      { aksiyon: "Aile Tatil Kampanyası kampanyasını açtı", zaman: "16:32", ikon: "ri-eye-line", renk: "#8B5CF6", sure: "5 dk kaldı" },
      { aksiyon: "Detay sayfasına geçti", zaman: "16:37", ikon: "ri-file-text-line", renk: "#F59E0B" },
      { aksiyon: "İkinci adıma geçti", zaman: "16:40", ikon: "ri-arrow-right-circle-line", renk: "#EC4899" },
      { aksiyon: "Form doldurdu", zaman: "16:44", ikon: "ri-file-edit-line", renk: "#10B981", basarili: true },
    ],
  },
  {
    id: 5,
    adSoyad: "Ali Çelik",
    telefon: "0542 XXX XX 89",
    telefonTam: "0542 789 56 89",
    kampanya: "Kış Tatili Özel Teklif",
    asama: 2,
    toplamAsama: 5,
    whatsapp: false,
    tarih: "2025-04-02T14:20:00",
    email: "ali.celik@email.com",
    timeline: [
      { aksiyon: "Siteye giriş yaptı", zaman: "14:20", ikon: "ri-global-line", renk: "#2B6EFD" },
      { aksiyon: "Kış Tatili Özel Teklif kampanyasını açtı", zaman: "14:22", ikon: "ri-eye-line", renk: "#8B5CF6", sure: "1 dk kaldı" },
      { aksiyon: "Kampanya sayfasında çıkış yaptı", zaman: "14:23", ikon: "ri-logout-box-line", renk: "#EF4444", kayip: true },
    ],
  },
  {
    id: 6,
    adSoyad: "Selin Yıldız",
    telefon: "0551 XXX XX 34",
    telefonTam: "0551 234 78 34",
    kampanya: "Erken Rezervasyon Fırsatı",
    asama: 4,
    toplamAsama: 5,
    whatsapp: true,
    tarih: "2025-04-02T11:10:00",
    email: "selin.yildiz@email.com",
    timeline: [
      { aksiyon: "Siteye giriş yaptı", zaman: "11:10", ikon: "ri-global-line", renk: "#2B6EFD" },
      { aksiyon: "Erken Rezervasyon Fırsatı kampanyasını açtı", zaman: "11:12", ikon: "ri-eye-line", renk: "#8B5CF6", sure: "7 dk kaldı" },
      { aksiyon: "Detay sayfasına geçti", zaman: "11:19", ikon: "ri-file-text-line", renk: "#F59E0B" },
      { aksiyon: "İkinci adıma geçti", zaman: "11:22", ikon: "ri-arrow-right-circle-line", renk: "#EC4899" },
      { aksiyon: "WhatsApp butonuna tıkladı", zaman: "11:25", ikon: "ri-whatsapp-line", renk: "#25D366", basarili: true },
    ],
  },
];

export const whatsappHareketleri = [
  { id: 1, adSoyad: "Ahmet Yılmaz", kampanya: "Yaz Tatili Paketi 2025", saat: "10:35", tarih: "Bugün", cihaz: "Mobil", durum: "Mesaj Gönderildi" },
  { id: 2, adSoyad: "Fatma Kaya", kampanya: "Erken Rezervasyon Fırsatı", saat: "09:29", tarih: "Bugün", cihaz: "Masaüstü", durum: "Mesaj Gönderildi" },
  { id: 3, adSoyad: "Selin Yıldız", kampanya: "Erken Rezervasyon Fırsatı", saat: "11:25", tarih: "Bugün", cihaz: "Mobil", durum: "Mesaj Gönderildi" },
  { id: 4, adSoyad: "Burak Şahin", kampanya: "Balayı Özel Paketi", saat: "14:12", tarih: "Dün", cihaz: "Mobil", durum: "Mesaj Gönderildi" },
  { id: 5, adSoyad: "Merve Koç", kampanya: "Kış Tatili Özel Teklif", saat: "16:48", tarih: "Dün", cihaz: "Masaüstü", durum: "Mesaj Gönderildi" },
  { id: 6, adSoyad: "Emre Aydın", kampanya: "Aile Tatil Kampanyası", saat: "09:05", tarih: "Dün", cihaz: "Mobil", durum: "Mesaj Gönderildi" },
  { id: 7, adSoyad: "Hande Öztürk", kampanya: "Yaz Tatili Paketi 2025", saat: "11:33", tarih: "2 gün önce", cihaz: "Mobil", durum: "Mesaj Gönderildi" },
  { id: 8, adSoyad: "Kemal Doğan", kampanya: "Erken Rezervasyon Fırsatı", saat: "15:20", tarih: "2 gün önce", cihaz: "Masaüstü", durum: "Mesaj Gönderildi" },
];

export const saatlikWhatsapp = [
  { saat: "08:00", tiklama: 12 },
  { saat: "09:00", tiklama: 34 },
  { saat: "10:00", tiklama: 67 },
  { saat: "11:00", tiklama: 89 },
  { saat: "12:00", tiklama: 54 },
  { saat: "13:00", tiklama: 43 },
  { saat: "14:00", tiklama: 78 },
  { saat: "15:00", tiklama: 92 },
  { saat: "16:00", tiklama: 110 },
  { saat: "17:00", tiklama: 87 },
  { saat: "18:00", tiklama: 65 },
  { saat: "19:00", tiklama: 48 },
  { saat: "20:00", tiklama: 32 },
  { saat: "21:00", tiklama: 21 },
];

export const popuplar = [
  {
    id: 1,
    ad: "Yaz Fırsatı Popup",
    gosterim: 8420,
    formDolduran: 1240,
    donusumOrani: 14.7,
    kampanya: "Yaz Tatili Paketi 2025",
    renk: "#F59E0B",
    insight: "Bu teklif daha fazla veri topluyor",
    karsilastirma: 23,
  },
  {
    id: 2,
    ad: "Erken Rezervasyon Teklifi",
    gosterim: 5210,
    formDolduran: 1820,
    donusumOrani: 34.9,
    kampanya: "Erken Rezervasyon Fırsatı",
    renk: "#10B981",
    insight: "En yüksek dönüşüm oranına sahip popup",
    karsilastirma: 67,
  },
  {
    id: 3,
    ad: "Balayı Özel Teklif",
    gosterim: 3180,
    formDolduran: 540,
    donusumOrani: 17.0,
    kampanya: "Balayı Özel Paketi",
    renk: "#EC4899",
    insight: "Görüntülenme yüksek, form doldurma düşük",
    karsilastirma: -8,
  },
  {
    id: 4,
    ad: "Aile Paketi Popup",
    gosterim: 4760,
    formDolduran: 820,
    donusumOrani: 17.2,
    kampanya: "Aile Tatil Kampanyası",
    renk: "#8B5CF6",
    insight: "Ortalama performans gösteriyor",
    karsilastirma: 5,
  },
];

export const reklamTalepleri = [
  {
    id: 1,
    firma: "Güneş Turizm A.Ş.",
    kampanya: "Yaz Tatili Paketi 2025",
    platform: ["Instagram", "Facebook"],
    butce: "₺15.000",
    durum: "İşlemde",
    tarih: "2025-04-01",
  },
  {
    id: 2,
    firma: "Mavi Deniz Tatil",
    kampanya: "Erken Rezervasyon Fırsatı",
    platform: ["Instagram"],
    butce: "₺8.500",
    durum: "Tamamlandı",
    tarih: "2025-03-28",
  },
  {
    id: 3,
    firma: "Rüya Balayı Organizasyon",
    kampanya: "Balayı Özel Paketi",
    platform: ["Facebook"],
    butce: "₺12.000",
    durum: "Bekliyor",
    tarih: "2025-04-03",
  },
  {
    id: 4,
    firma: "Aile Tatil Merkezi",
    kampanya: "Aile Tatil Kampanyası",
    platform: ["Instagram", "Facebook"],
    butce: "₺20.000",
    durum: "Bekliyor",
    tarih: "2025-04-02",
  },
  {
    id: 5,
    firma: "Kar Tatil Köyü",
    kampanya: "Kış Tatili Özel Teklif",
    platform: ["Instagram"],
    butce: "₺6.000",
    durum: "Tamamlandı",
    tarih: "2025-03-25",
  },
];
